import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React from 'react';
import { connect } from "react-redux";
import Details from './Details.js'
import PosProstor from './PosProstor.js'
import NaplatniUredaji from './NaplatniUredaj'
import './tabs.scss';

export class TabContainer extends React.Component{
    render(){  

        return(
            <div className="dashboardTabs">
                <Tabs>
                    <TabList>
                    <Tab>Klijent</Tab>
                    <Tab>Poslovni prostori</Tab>
                    <Tab>Naplatni uređaji</Tab>
                    </TabList>
                    <hr style={{padding: "0px",
                        margin: "0px",
                        border: "1px solid #808080"}}
                    />
                    <TabPanel>
                        <Details />
                    </TabPanel>
                    <TabPanel>
                        <PosProstor />
                    </TabPanel>
                    <TabPanel>
                        <NaplatniUredaji props={this.props.devices}/>
                    </TabPanel>
                </Tabs>
            </div>
        )
    };
};

const mapStateToProps = state => {
    return {
        userLoggedIn: state.client.userLoggedIn,
        devices: state.client.devices,
        credentials: state.client.credentials
        
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(TabContainer);
